import React from 'react';
import { cn } from '../../../utils/cn';

const PageHeader = ({ 
  title,
  subtitle,
  actions = [],
  variant = 'default',
  className,
  ...props 
}) => {
  const variants = {
    default: 'border-b border-gray-200 bg-white',
    transparent: 'bg-transparent',
    glass: 'bg-white/80 backdrop-blur-sm border-b border-white/20'
  };

  return (
    <div
      className={cn(
        'sticky top-0 z-40',
        variants[variant],
        className
      )}
      {...props}
    >
      <div className="px-6 py-4">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          {/* Title Section */}
          <div className="min-w-0">
            <h1 className="text-2xl font-bold text-gray-900 tracking-tight">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-1 text-sm text-gray-600">
                {subtitle}
              </p>
            )}
          </div>
          
          {/* Actions Section */}
          {actions.length > 0 && (
            <div className="flex items-center gap-3 flex-wrap justify-start md:justify-end">
              {actions.map((action, index) => (
                <div key={index}>
                  {action}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;